// Bounds how many rows a measured section may show, capped by the preview API's maximum limit.
export const PROBE_ROW_COUNTS = [0, 1, 2, 3, 4, 5, 6] as const;
